import type { FC } from "react";

import { StoreLocatorLayoutSwitcher } from "@locators/components/shared/components/StoreLocatorLayoutSwitcher/StoreLocatorLayoutSwitcher";
import { StoreLocatorProviderWrapper } from "@locators/components/shared/components/StoreLocatorProviderWrapper";
import { StoreLocatorContext } from "@locators/components/shared/context";
import { useStoreLocator } from "@locators/components/shared/hooks";
import type { StoreLocatorProps } from "@locators/components/shared/types";

import { useConfig } from "@jti/app-context/useConfig";

import { StoreLocatorV1 } from "./components/StoreLocatorV1";
import { StoreLocatorV2 } from "./components/StoreLocatorV2";

// Re-export types for backward compatibility
export type { StoreExtendedParams, StoreIcons, StoreLocatorProps } from "@locators/components/shared/types";

export const StoreLocator: FC<StoreLocatorProps> = (props) => {
  const { flotiqApiKey, flotiqContentType, componentLevelLanguage } = props;
  const { FLOTIQ_API_KEY, STORE_LOCATOR_CONTENT_TYPE } = useConfig();
  const storeLocatorData = useStoreLocator({
    ...props,
    flotiqApiKey: flotiqApiKey ?? FLOTIQ_API_KEY,
    flotiqContentType: flotiqContentType ?? STORE_LOCATOR_CONTENT_TYPE,
  });

  return (
    <StoreLocatorProviderWrapper componentLevelLanguage={componentLevelLanguage}>
      <StoreLocatorContext.Provider value={storeLocatorData}>
        <StoreLocatorLayoutSwitcher layout="v1">
          <StoreLocatorV1 />
        </StoreLocatorLayoutSwitcher>
        <StoreLocatorLayoutSwitcher layout="v2">
          <StoreLocatorV2 />
        </StoreLocatorLayoutSwitcher>
      </StoreLocatorContext.Provider>
    </StoreLocatorProviderWrapper>
  );
};
